module.exports = __webpack_public_path__ + "img/consecuencia5.c655befe.png";